/* eslint-disable max-len */
import React from 'react'

export default function Amounts({ state, getRemainingAmount }) {
    return (
        <div>
            <div className='flex items-center mt-8' style={{ 'width': '75%' }}>
                <p className='text-lg font-normal text-black w-[100%] justify-end inline-flex'>
                    <span className='w-[35%] justify-end inline-flex text-[#106EB4] mr-5'>Total Applied Amount</span>
                    <span className='min-w-[13%] justify-end inline-flex'>
                        {isNaN(state.invoices.reduce((sum, invoice) => (invoice.items.forEach(item => sum += item.received_line_amount), sum), 0).toFixed(2)) ? "0.00" : state.invoices.reduce((sum, invoice) => (invoice.items.forEach(item => sum += item.received_line_amount), sum), 0).toFixed(2)}
                    </span>
                </p>
            </div>
            <div className='flex items-center mt-2' style={{ 'width': '75%' }}>
                <p className='text-lg font-normal text-black w-[100%] justify-end inline-flex'>
                    <span className='w-[35%] justify-end inline-flex text-[#106EB4] mr-5'>Remaining Amount</span>
                    <span className='min-w-[13%] justify-end inline-flex'>
                        {isNaN(getRemainingAmount()) ? "0.00" : getRemainingAmount()}
                    </span>
                </p>
            </div>
        </div >
    )
}
